export default "__VITE_ASSET__CKjhflPy__"